/**
 * Recursively removes all null and undefined values from an object, including in nested objects and arrays
 * @param obj - The object to clean of null/undefined values
 * @returns A new object with all null/undefined values removed
 */
export const cleanNullValues = (obj: any): any => {
  // Return directly if obj is null, undefined or not an object
  if (obj === null || obj === undefined || typeof obj !== 'object') {
    return obj;
  }

  // Handle arrays
  if (Array.isArray(obj)) {
    return obj
      .filter(item => item !== null && item !== undefined)
      .map(item => cleanNullValues(item));
  }

  // Handle objects
  return Object.entries(obj).reduce<Record<string, any>>((acc, [key, value]) => {
    // Skip null or undefined values
    if (value === null || value === undefined) {
      return acc;
    }

    // Recursively clean nested objects
    if (typeof value === 'object') {
      const cleaned = cleanNullValues(value);
      
      // Only add non-empty objects (objects with at least one property)
      if (Array.isArray(cleaned) ? cleaned.length > 0 : Object.keys(cleaned).length > 0) {
        acc[key] = cleaned;
      }
    } else {
      // Add primitive values directly
      acc[key] = value;
    }
    
    return acc;
  }, {});
};
